import { $ as e, C as t, F as n, L as r, _ as i, d as a, h as o, i as s, ot as c, p as l, rt as u, t as d, v as f, w as p } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as m } from "./normalize-props-DNjMoRjC.js";
//#region src/webcomponents/flip-cards/FlipCard.ce.vue?vue&type=script&setup=true&lang.ts
var h = ["aria-hidden"], g = ["src"], _ = ["aria-level"], v = ["aria-hidden"], y = ["aria-level"], b = { class: "description" }, x = { class: "image-container" }, S = ["src"], C = /*#__PURE__*/ d(/* @__PURE__ */ p({
	__name: "FlipCard.ce",
	props: {
		titleLevel: { type: Number },
		color: { type: String },
		description: { type: String },
		icon: { type: String },
		image: { type: String },
		isFlipped: { type: Boolean },
		name: { type: String }
	},
	setup(e) {
		return (t, r) => (n(), f(l, null, [o("div", {
			class: u(["card recto", `${e.color}`]),
			"aria-hidden": e.isFlipped ? "true" : "false"
		}, [o("img", {
			class: "icon",
			src: e.icon,
			alt: ""
		}, null, 8, g), o("div", {
			role: "heading",
			"aria-level": e.titleLevel,
			class: "title"
		}, c(e.name), 9, _)], 10, h), o("div", {
			class: u(["card verso", {
				flipped: e.isFlipped,
				[e.color]: e.color
			}]),
			"aria-hidden": e.isFlipped ? "false" : "true"
		}, [
			o("div", {
				role: "heading",
				"aria-level": e.titleLevel,
				class: "title"
			}, c(e.name), 9, y),
			o("p", b, c(e.description), 1),
			o("div", x, [e.image ? (n(), f("img", {
				key: 0,
				src: e.image,
				alt: ""
			}, null, 8, S)) : i("", !0)])
		], 10, v)], 64));
	}
}), [["styles", ["[data-v-042dbbc1]{box-sizing:border-box}.card[data-v-042dbbc1]{backface-visibility:hidden;color:#253858;background:#fff;border-radius:12px;flex-direction:column;justify-content:center;align-items:center;gap:1.2rem;padding:18px;transition:transform .5s;display:flex;position:absolute;inset:0;transform:translateZ(0)}.card .title[data-v-042dbbc1]{font-family:Nunito,sans-serif;font-size:1rem;font-weight:700;line-height:29px}.card.recto.red[data-v-042dbbc1]{background:linear-gradient(150deg,#fff 0%,#ff7373 100%)}.card.recto.yellow[data-v-042dbbc1]{background:linear-gradient(150deg,#fff 0%,#ffec73 100%)}.card.recto.blue[data-v-042dbbc1]{background:linear-gradient(150deg,#fff 0%,#2491ff 100%)}.card.recto.purple[data-v-042dbbc1]{background:linear-gradient(150deg,#fff 0%,#9177f2 100%)}.card.recto.green[data-v-042dbbc1]{background:linear-gradient(150deg,#fff 0%,#52d987 100%)}.card.recto.pink[data-v-042dbbc1]{background:linear-gradient(150deg,#fff 0%,#f041bf 100%)}.card.recto .icon[data-v-042dbbc1]{width:40px;height:auto;display:block}.card.verso[data-v-042dbbc1]{text-align:center;padding:8px;line-height:1.2rem;transform:rotateY(180deg)translateZ(0)}.card.verso.flipped.red[data-v-042dbbc1]{border:2px solid #ff7373}.card.verso.flipped.yellow[data-v-042dbbc1]{border:2px solid #ffec73}.card.verso.flipped.blue[data-v-042dbbc1]{border:2px solid #2491ff}.card.verso.flipped.purple[data-v-042dbbc1]{border:2px solid #9177f2}.card.verso.flipped.green[data-v-042dbbc1]{border:2px solid #52d987}.card.verso.flipped.pink[data-v-042dbbc1]{border:2px solid #f041bf}.card.verso .description[data-v-042dbbc1]{margin:0 0 8px;font-size:.9rem}.card.verso .image-container[data-v-042dbbc1]{width:160px;margin:8px 8px 16px;overflow:hidden}.card.verso img[data-v-042dbbc1]{object-fit:contain;width:100%;height:100%;display:block}"]], ["__scopeId", "data-v-042dbbc1"]]), w = { class: "flip-cards" }, T = ["aria-level"], E = [
	"aria-expanded",
	"onClick",
	"onKeydown"
], D = { class: "flip-container" }, O = s(/* @__PURE__ */ d(/* @__PURE__ */ p({
	__name: "FlipCards.ce",
	props: {
		titleLevel: {
			default: 2,
			type: Number
		},
		name: { type: String },
		cardList: { type: Array }
	},
	setup(i) {
		let s = [
			"red",
			"yellow",
			"blue",
			"purple",
			"green",
			"pink"
		], d = e(i.cardList.map((e, t) => ({
			...e,
			color: s[t % s.length],
			isFlipped: !1
		}))), p = (e, t) => {
			t.preventDefault(), e.isFlipped = !e.isFlipped;
		};
		return (e, s) => (n(), f("div", w, [o("div", {
			role: "heading",
			"aria-level": i.titleLevel,
			class: "sr-only"
		}, c(i.name), 9, T), (n(!0), f(l, null, r(d.value, (e, r) => (n(), f("div", {
			key: r,
			class: u(["card-container", {
				flipped: e.isFlipped,
				[e.color]: e.color
			}]),
			role: "button",
			tabindex: "0",
			"aria-expanded": e.isFlipped,
			onClick: (t) => p(e, t),
			onKeydown: [a((t) => p(e, t), ["enter"]), a((t) => p(e, t), ["space"])]
		}, [o("div", D, [t(C, {
			color: e.color,
			description: e.description,
			icon: e.icon,
			image: e.image,
			"is-flipped": e.isFlipped,
			name: e.name,
			"title-level": i.titleLevel + 1
		}, null, 8, [
			"color",
			"description",
			"icon",
			"image",
			"is-flipped",
			"name",
			"title-level"
		])])], 42, E))), 128))]));
	}
}), [["styles", ["[data-v-98a76b7e]{box-sizing:border-box}.sr-only[data-v-98a76b7e]{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.flip-cards[data-v-98a76b7e]{flex-wrap:wrap;justify-content:center;gap:1.5rem;max-width:100%;padding:0;display:flex}.flip-cards .card-container[data-v-98a76b7e]{cursor:pointer;perspective:1200px;outline:none;flex:0 0 180px;height:250px;margin:0;transition:transform .5s;transform:scale(1)}.flip-cards .card-container[data-v-98a76b7e]:hover,.flip-cards .card-container[data-v-98a76b7e]:focus{outline:none;transition:transform .5s;transform:scale(1.05)}.flip-cards .card-container .flip-container[data-v-98a76b7e]{width:100%;height:100%;transform-style:preserve-3d;will-change:transform;padding:18px;transition:transform .6s cubic-bezier(.2,.8,.2,1);display:block;position:relative}.flip-cards .card-container.flipped .flip-container[data-v-98a76b7e]{transform:rotateY(180deg)}"]], ["__scopeId", "data-v-98a76b7e"]]));
O.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: m(e.titleLevel)
}), window.customElements.define("flip-cards", O);
//#endregion
